const AlertIconFilled = ({ color, width, height }) => {
  return (
    <svg
      width={width ? width : "13"}
      height={height ? height :"13"}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6C0 2.68652 2.68555 0 6 0C9.31445 0 12 2.68652 12 6C12 9.31348 9.31445 12 6 12C2.68555 12 0 9.31348 0 6ZM6 3.33398C5.63086 3.33398 5.33203 3.03516 5.33203 2.66699C5.33203 2.46289 5.42383 2.28027 5.56836 2.1582C5.68555 2.06055 5.83594 2.00098 6 2.00098C6.36719 2.00098 6.66602 2.29883 6.66602 2.66699C6.66602 3.03516 6.36719 3.33398 6 3.33398ZM5.33203 9.33301C5.33203 9.70117 5.63086 10 6 10C6.36719 10 6.66602 9.70117 6.66602 9.33301V5.33301C6.66602 4.96484 6.36719 4.66699 6 4.66699C5.63086 4.66699 5.33203 4.96484 5.33203 5.33301V9.33301Z"
        fill={color}
      />
    </svg>
  );
};

export default AlertIconFilled;
